<template>
    <!-- 评论区 -->
    <van-popup v-model:show="show" round position="bottom" :style="{height: '40%'}">
        <van-form class="form" @submit="onSubmit">
            <van-field
                v-model="content"
                name="评论"
                label="评论"
                placeholder="评论经审核后公开"
                :rules="[{ required: true, message: '请填写评论' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">发布</van-button>
            </div>
        </van-form>
    </van-popup>
</template>

<script>
import {doComment} from "@/api/CommonApi";
import {Toast} from "vant";

export default {
    name: "CommentPopup",
    inject:['resourceItemId'],
    data(){
        return{
            show:false,
            content:'',
        }
    },
    methods:{
        showPopup(){
            this.show = true
        },
        onSubmit(){
            doComment({
                itemId:this.resourceItemId,
                content:this.content
            }).then(res => {
                console.log(res)
                Toast.success(res.message)
                this.$emit('comment-success',this.content)
                this.show = false
                this.content = ''

            })
        }
    }
}
</script>

<style scoped>
.form{
    padding: 20px 10px;
}
</style>
